var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticStyle:{"padding-top":"50px","text-align":"center","width":"100%"}},[_c('span',{staticClass:"text-gradient"},[_vm._v("404")]),_c('br'),_c('div',{staticClass:"pa-2 pt-6",staticStyle:{"margin":"auto"}},[_vm._v(" 페이지를 찾을 수 없습니다. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }